"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Root = void 0;
var tslib_1 = require("tslib");
var ui_helper_props_to_styles_1 = require("@hopin-team/ui-helper-props-to-styles");
var ui_symbols_1 = require("@hopin-team/ui-symbols");
var styled_components_1 = tslib_1.__importStar(require("styled-components"));
var makeScaleStyles = function (scale) { return (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  height: ", ";\n  width: auto;\n"], ["\n  height: ", ";\n  width: auto;\n"])), (0, ui_symbols_1.calcSpace)(scale)); };
var flexibleStyles = "\n  height: 100%;\n  width: 100%;\n";
exports.Root = styled_components_1.default.div.withConfig({
    shouldForwardProp: function (prop) { return !['scale', 'isFlexible'].includes(prop); },
})(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  display: inline-flex;\n\n  ", "\n"], ["\n  display: inline-flex;\n\n  ", "\n"])), function (props) {
    return !props.isFlexible
        ? (0, ui_helper_props_to_styles_1.makeStyles)(props, 'scale', makeScaleStyles)
        : flexibleStyles;
});
var templateObject_1, templateObject_2;
//# sourceMappingURL=root.js.map